module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/eye_lg-d97b18e038c0552fada075b108edff02.jpg";